import { useDesignElementManager } from "@hooks/use-design-element-manager";

import { type Platform } from "../constants";
import { usePlatformsMetadata } from "../metadata";

const PlatformIcon = ({
  platform,
  size = 8,
}: {
  platform: Platform;
  size?: number;
}) => {
  const { getMetadata } = usePlatformsMetadata();
  const { designElementManager } = useDesignElementManager();
  const metadata = getMetadata(platform);
  return (
    <div className="relative">
      {designElementManager
        .getDesignElement(metadata.iconName || platform)
        .getComponent({ size: `${size * 4}px` })}
    </div>
  );
};

export default PlatformIcon;
